import styled from '@nfinite/react-hubstairs/styled'

const BADGE_WIDTH_RATIO = '50%'
const BADGE_TOP_OFFSET = '5%'
const BADGE_Z_INDEX = 10

export const DemoBadgeWrapper = styled('div')`
  position: absolute;
  width: ${BADGE_WIDTH_RATIO};
  top: ${BADGE_TOP_OFFSET};
  left: 0;
  z-index: ${BADGE_Z_INDEX};
`
